import { isDefined } from '../../ramda/index.tsx';
import { SCENARIO_ISSUE_ID_PREFIX } from '../constant.tsx';

// An issue is not created in Jira if it still has a scenario format ID
export const isScenarioIssue = (issueId: string | null | undefined = '') =>
	isDefined(issueId) && issueId.startsWith(SCENARIO_ISSUE_ID_PREFIX);
